module.exports = __webpack_public_path__ + "static/media/hands.e0f626f0.png";